module.exports = "/images/SS Logo-Black.svg?c5394676a9f9343b7db73a8d49fee855";